import {LocalStorage} from "./LocalStorage";

// Devuelve true si el user logueado es SuperAdmin.
export function isSuperAdmin() {
    return LocalStorage.fetchIsSuperAdmin();
}

// AgencyCustomMetric feature flag (D11 confirmado por Pablo 2026-05-22).
// El flag viene del backend en `GET dashboard/basic-data` como
// `custom_metrics_enabled` (boolean per-agency). Persistido en LocalStorage
// para que el router y los componentes que no reciben el flag por props
// puedan gatear sin necesidad de re-fetchear. Refresca con el próximo basic-data.
export function isCustomMetricsEnabled() {
    return LocalStorage.fetchCustomMetricsEnabled() === true;
}

// Tri-state: true | false | null. null = todavía no hidratado (no se cargó basic-data).
// Lo usa el RouteGuard para distinguir "deshabilitado" de "no sé todavía".
export function getCustomMetricsEnabledState() {
    return LocalStorage.fetchCustomMetricsEnabled();
}

export function setCustomMetricsEnabled(enabled) {
    LocalStorage.updateCustomMetricsEnabled(!!enabled);
}

// Toggle de modalidad del Tablero del portal (Tablero vs Cards).
// Se estandarizó a todos los portales en modalidad Tablero (default backend
// TABLE_V2). El toggle para volver a Cards solo se expone al equipo Dashbo
// (SuperAdmins) — las agencias clientes no lo ven para evitar confusión.
export function isPortalModalityToggleEnabled() {
    return isSuperAdmin();
}
